import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询部门人员 API_SEARCH_MEMBERS
  fishnetSearachMembers(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SEARCH_MEMBERS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * 上传临时图片
   * @param Object postData
   */
  async fishnetUploadTempPicByBinary(postData) {
    return http.uploadFile(URL.API_FISHNET_UPLOAD_TEMP_PIC_BY_BINARY, postData)
  },
  /**
   * 获取子部门列表
   * @param Object postData
   */
  async fishnetGetsubDepts(postData) {
    return http.get(URL.API_FISHNET_GET_SUB_DEPTS, postData)
  },
  /**
   * 获取部门成员列表
   * @param Object postData
   */
  async fishnetGetDeptMembers(postData) {
    return http.get(URL.API_FISHNET_GET_DEPT_MEMBERS, postData)
  },
  /**
   * 获取用户信息
   * @param Object postData
   */
  async fishnetGetSimpleInfoByIds(postData) {
    return http.post(URL.API_FISHNET_INFO_BY_IDS, postData)
  },
  /**
   * 查询部门详细
   * @param Object postData
   */
  async fishnetGetDeptInfoByIds(postData) {
    return http.post(URL.API_FISHNET_DEPTS_BY_IDS, postData)
  },
  /**
   * 获取成员基本信息(不含部门)
   * @param Object postData
   */
  async fishnetGetMemberInfo(postData) {
    return http.get(URL.API_FISHNET_GET_MEMBER_INFO, postData)
  },
  /**
   * 查询成员
   * @param Object postData
   */
  async fishnetGetMembersByKey(postData) {
    return http.get(URL.API_FISHNET_GET_MEMBERS_BY_KEY, postData)
  },
  /**
   * 通过tpId获取成员标签
   * @param Object postData
   */
  async fishnetGetTpIdTags(postData) {
    return http.post(URL.API_FISHNET_GET_TPID_TAGS, postData)
  },

  // 查询部门详情 API_FISHNET_GET_DEPT_INFO
  fishnetGetDeptInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_FISHNET_GET_DEPT_INFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * Debug
   * @param Object postData
   */
  async fishnetDebug(message) {
    let _postData = { message: message }
    return http.post(URL.API_FISHNET_DEBUG, _postData)
  }
}
